function TableData({ children, width }) {
  return (
    <td
      className={`text-[14px] whitespace-nowrap text-black text-left pl-[24px] pr-[20px] truncate`}
      style={{ width: width ?? "auto" }}
    >
      {children}
    </td>
  );
}

export default TableData;
